import { Draggable, Droppable } from 'react-beautiful-dnd';
import { MenuItem, useTheme } from '@mui/material';
import { CcfDraggableIcon, CcfTypography } from '@nice-ccf/ui-controls';
import { ColumnDefinitions, getDefaultColumns } from '../ccf-interaction-search.slice';
import CcfInteractionSearchStyle from '../ccf-interaction-search-styles';
import { useSelector } from 'react-redux';
import { ColumnType } from './ccf-interaction-search-customizable-menu';
import { getStyle } from './ccf-draggable-columns-styles';

/**
 * Interface for defining props of CcfCustomizableColumns component
 */
export interface CcfDraggableColumnsProps {
  /**
   * @remarks - droppable id from each droppable section
   */
  droppableId: string;
}
/**
 * CcfCustomizableColumns - to display list of interaction search columns
 * @example - `<CcfCustomizableColumns />`
 */
export const CcfDraggableColumns = (props: CcfDraggableColumnsProps) => {
  const defaultColumns = useSelector(getDefaultColumns);
  const { droppableId } = props;
  const columns =
    defaultColumns.filter((col: ColumnDefinitions) => {
      return droppableId === ColumnType.SELECTED_COLUMNS ? !col.hide && col.headerName: col.hide && col.headerName
    })
  const theme = useTheme();
  const styles = CcfInteractionSearchStyle(theme);
  
  return (
    <Droppable droppableId={droppableId}>
      {(provided, snapshot) => (
        <div {...provided.droppableProps} ref={provided.innerRef}>
          {columns.map((item: ColumnDefinitions, index: number) => (
            <Draggable key={item.field} draggableId={item.field} index={index}>
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  style={getStyle(snapshot, provided.draggableProps.style, theme)}
                >
                  <MenuItem
                    key={item.field}
                    data-testid={`option-${item.field}`}
                    sx={styles.menuItem}
                    dense
                  >
                    <CcfDraggableIcon fontSize="small" />
                    <CcfTypography sx={{ fontSize: '0.75rem' }}>{item.headerName}</CcfTypography>
                  </MenuItem>
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};
